/** Canonical Support ticket priority tokens (payload / DB). Labels are i18n-only. */
export const SUPPORT_TICKET_PRIORITIES = Object.freeze(['low', 'normal', 'high', 'blocker']);

export const SUPPORT_TICKET_PRIORITY_DEFAULT = 'normal';

export function isSupportTicketPriority(value) {
  return SUPPORT_TICKET_PRIORITIES.includes(String(value ?? '').trim().toLowerCase());
}

export function normalizeSupportTicketPriority(value) {
  const raw = String(value ?? '').trim().toLowerCase();
  return isSupportTicketPriority(raw) ? raw : SUPPORT_TICKET_PRIORITY_DEFAULT;
}

/**
 * Build create/update FormData-safe priority field.
 * Translated labels must never enter the payload.
 */
export function buildSupportTicketPriorityField(priority) {
  return { priority: normalizeSupportTicketPriority(priority) };
}
